'use strict';

module.exports = require('./RelyingParty');


//////////////////
// WEBPACK FOOTER
// ../solid-auth-oidc/~/oidc-rp/lib/index.js
// module id = 90
// module chunks = 0